<template>
  <div class="default-layout">
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { t } from '@/locale'
import useConfigStore from '@/store/modules/config'
import jsBridge from '@/utils/jsBridge'
import { useDialog } from 'naive-ui'

const configStore = useConfigStore()
const dialog = useDialog()

/**
 * 监听错误信息变化
 */
watch(
  () => configStore.errorInfo.show,
  (show) => {
    if (show) {
      showError()
    }
  },
  {
    immediate: true
  }
)

/**
 * 显示错误弹窗
 */
const showError = () => {
  if (dialog) {
    dialog.error({
      title: t('dex.system_tip'),
      content: t(configStore.errorInfo.message),
      positiveText: t('dex.retry'),
      closable: false,
      maskClosable: false,
      onPositiveClick: () => {
        handleErrorDialogConfirm()
      }
    })
  } else {
    // 如果 dialog 还未初始化，等待一下再尝试
    setTimeout(() => {
      showError()
    }, 100)
  }
}

/**
 * 处理错误弹窗确认
 */
const handleErrorDialogConfirm = () => {
  if (configStore.errorInfo.callback) {
    configStore.errorInfo.callback()
  }
  configStore.clearErrorInfo()
  jsBridge.callHandler('onRefreshPageWithToken', {}, (result) => {
    console.log('onRefreshPageWithToken success, result:', result)
    window.location.reload()
  })
}
</script>

<style scoped>
.default-layout {
  width: 100%;
  min-height: 100vh;
}
</style>